import { SxProps } from "@mui/material";

export const sxText: SxProps = {
  fontFamily: "Montserrat-Regular",
  fontSize: "var(--font-size-base)",
  lineHeight: "30px",
  letterSpacing: "0em",
  textWrap: 'wrap',
  '@media(max-width: 799px)': {
    width: '100%'
  }
};
